// Constants
import { POSITIONS, SnackbarMessageType } from '@openbank/ziniaweb-ui-components';

const SNACKBAR_PROPS = {
  closeIcon: { icon: 'icon_symbols_close-thick' },
  popover: {
    focusFirstDescendantAutomatically: false,
    trapFocusInsideModal: false,
  },
  variant: 'DEFAULT',
  icon: {
    icon: 'icon_symbols_information-in-a-circle',
  },
  type: SnackbarMessageType.WARNING,
  align: POSITIONS.BOTTOM_CENTER_FIXED,
};

export { SNACKBAR_PROPS };
